// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e71ba380","977":"2ebe8d77"}[chunkId] + ".chunk.js";
};